import apiDtMood from './dtMoodApiHandler'
import { getDtMoodSession } from './dtmood-session.service'

const getFaqs = () => {
  const dtMoodSession = getDtMoodSession()
  const clientId = dtMoodSession ? dtMoodSession.clientId : ''

  return new Promise((resolve, reject) => {
    apiDtMood
      .get(`/faqs/list/?clientId=${clientId}`)
      .then((res) => {
        resolve(res.data)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export { getFaqs }
